export default __webpack_public_path__ + "dd8125ead27254818e47e1a08814e83a.png";